module.exports = __webpack_public_path__ + "img/effectiveness.ed9afdc6.png";